"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBirthday = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const setDateOfBirth_1 = require("./setDateOfBirth");
const getBirthday = (departureAt, birthdayAt, seatType) => {
    if (birthdayAt) {
        return new Date(Number(birthdayAt) * 1000);
    }
    if (!seatType) {
        return;
    }
    const departureDate = new Date(departureAt);
    const childAge = retrieveChildAgeBasedOnSeatType(seatType);
    const dateOfBirth = (0, setDateOfBirth_1.setDateOfBirth)(departureDate, childAge);
    return dateOfBirth;
};
exports.getBirthday = getBirthday;
function retrieveChildAgeBasedOnSeatType(seatType) {
    switch (seatType) {
        case legacy_enums_1.PartnerApiChildSeat.RearFacing: {
            return 1;
        }
        case legacy_enums_1.PartnerApiChildSeat.ForwardFacing: {
            return 2;
        }
        case legacy_enums_1.PartnerApiChildSeat.BoosterSeat: {
            return 5;
        }
        case legacy_enums_1.PartnerApiChildSeat.Booster: {
            return 9;
        }
        default: {
            throw new Error("Incorrect child seats type");
        }
    }
}
//# sourceMappingURL=getBirthday.js.map